module.exports = fox._r("images/gifts/gift-8.png", __webpack_public_path__ + "_/_/_/_/common/liveshow/images/gifts/gift-8.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/common/liveshow/images/gifts/gift-8.png
// module id = 209
// module chunks = 4